import { NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent, DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { ClientAutocompleteComponent } from 'src/app/base/shared/client-autocomplete/client-autocomplete.component';
import { ThirdPartyUserAssignmentAdministrationService } from '../third-party-user-assignment-administration.service';
import { ThirdPartyUserAssignmentEditFormType } from './third-party-user-assignment-edit-form.type';
import { AutocompleteComponent } from 'src/app/base/shared/autocomplete/autocomplete.component';
import { Observable } from 'rxjs';
import { ClientDTO, ThirdPartyUserClientZoneAssignmentUserInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { ThirdPartyUserAssignmentEditZonesSelectorComponent } from './third-party-user-assignment-edit-zones-selector/third-party-user-assignment-edit-zones-selector.component';

@Component({
  selector: 'app-third-party-user-assignment-edit-dialog',
  templateUrl: './third-party-user-assignment-edit-dialog.component.html',
  styleUrls: ['./third-party-user-assignment-edit-dialog.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, DialogModule, TranslateModule, NgIf, ClientAutocompleteComponent, AppErrorMessagesComponent, AutocompleteComponent, ThirdPartyUserAssignmentEditZonesSelectorComponent, TooltipModule]
})
export class ThirdPartyUserAssignmentEditDialogComponent implements OnInit {
  @ViewChild('thirdPartyUserAssignmentDialog') public dialog: DialogComponent;
  @ViewChild(ThirdPartyUserAssignmentEditZonesSelectorComponent) public zonesSelector: ThirdPartyUserAssignmentEditZonesSelectorComponent;

  @Output() public refreshData: EventEmitter<void> = new EventEmitter<void>();

  public dropdownSettings = { text: 'userName', value: 'id' };

  public isAdd: boolean = false;
  public form: FormGroup<ThirdPartyUserAssignmentEditFormType> = this.fb.group<ThirdPartyUserAssignmentEditFormType>({
    userId: this.fb.control<string>(null, Validators.required),
    client: this.fb.control<ClientDTO>(null, Validators.required)
  });

  public set selectedUser(value: string) {
    this.form.controls.userId.setValue(value);
  }

  public get selectedUser(): string {
    return this.form.controls.userId.value;
  }

  constructor(private assignmentService: ThirdPartyUserAssignmentAdministrationService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
  }

  public openDialog(isAdd: boolean) {
    this.isAdd = isAdd;
    this.dialog.show();
  }

  public closeDialog() {
    this.dialog.hide();
    this.form.reset({userId: null, client: null});
    this.form.controls.client.markAsUntouched();
    this.form.controls.client.markAsPristine();
  }

  public onExecute() {
    if (this.form.invalid) {
      return;
    }

    if (this.isAdd) {
      let selectedZoneIds = this.zonesSelector?.getSelectedZoneIds();
      if (selectedZoneIds?.length === 0) {
        selectedZoneIds = null;
      }
      this.assignmentService.createAssignments(this.form.controls.userId.value, this.form.controls.client.value?.id, selectedZoneIds).subscribe(() => {
          this.refreshData.emit();
          this.closeDialog();
        }
      );
    } else {
      this.assignmentService.bulkDeleteRecords(this.form.controls.userId.value, this.form.controls.client.value?.id).subscribe(() => {
          this.refreshData.emit();
          this.closeDialog();
        }
      );
    }
  }

  public getThirdPartyUsers(searchText: string): Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]> {
    return this.assignmentService.searchThirdPartyUsers(searchText);
  }
}
